import type { AxiosInstance } from "axios";

import type {
  CreateUserDirectoryInstanceUnbranded,
  UpdateUserDirectoryInstanceUnbranded,
  UserDirectoryInstanceIdUnbranded,
  UserDirectoryInstanceUnbranded,
} from "@thalamos/vision-common";

import { useApiAxios } from "../axios/api.js";

export const config = {
  userDirectoryInstance: {
    getAll: () => ({
      url: `/api/user-directory-instance/`,
      method: "get",
    }),
    create: (
      id: UserDirectoryInstanceIdUnbranded,
      data: CreateUserDirectoryInstanceUnbranded,
    ) => ({
      url: `/api/user-directory-instance/${id}`,
      method: "post",
      data,
    }),
    update: (
      id: UserDirectoryInstanceIdUnbranded,
      data: UpdateUserDirectoryInstanceUnbranded,
    ) => ({
      url: `/api/user-directory-instance/${id}`,
      method: "put",
      data,
    }),
    delete: (id: UserDirectoryInstanceIdUnbranded) => ({
      url: `/api/user-directory-instance/${id}/delete`,
      method: "post",
    }),
  },
};

export const api = (apiAxios: AxiosInstance) => {
  return {
    userDirectoryInstance: {
      create: (
        id: UserDirectoryInstanceIdUnbranded,
        data: CreateUserDirectoryInstanceUnbranded,
      ) => apiAxios.request(config.userDirectoryInstance.create(id, data)),
      update: (
        id: UserDirectoryInstanceIdUnbranded,
        data: UpdateUserDirectoryInstanceUnbranded,
      ) => apiAxios.request(config.userDirectoryInstance.update(id, data)),
      delete: (id: UserDirectoryInstanceIdUnbranded) =>
        apiAxios.request(config.userDirectoryInstance.delete(id)),
    },
  };
};

export const apiHooks = () => {
  return {
    userDirectoryInstance: {
      getAll: () => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return useApiAxios<UserDirectoryInstanceUnbranded[]>(
          config.userDirectoryInstance.getAll(),
        );
      },
    },
  };
};
